<template>
	<div>
		<div style="padding: 6px;font-size: 16px;"
			v-if="selectdItem.compontChildren[0].data.img.list[0].url == ''  && type == 'design'">
			请添加图片
		</div>
		<div style="display: grid;max-width: 100%;justify-content: space-between;"
			v-if="selectdItem.compontChildren[0].data.img.list[0].url != '' && show && selectdItem.compontChildren[0].layoutConfig.img.typesetting == 'default'"
			:style="getColumns()">
			<img-items v-for="(item,index) in list" :key="index" :imgItem="item" :equipment="equipment"
				:selectdItem="selectdItem" :systemConfig="systemConfig" :type="type"></img-items>
		</div>
		<div style="display: grid;max-width: 100%;width: 100%;justify-content: space-around;"
			v-if="selectdItem.compontChildren[0].data.img.list[0].url != '' && show && selectdItem.compontChildren[0].layoutConfig.img.typesetting == 'lr'"
			:style="{
			...getColumnsLR(),
			 justifyItems:selectdItem.containerLayout.justify
		}">
			<img-items style="width: fit-content;" v-for="(item,index) in list" :key="index" :imgItem="item"
				:equipment="equipment" :selectdItem="selectdItem" :systemConfig="systemConfig" :type="type"></img-items>
		</div>

	</div>
</template>

<script>
	import imgItems from './imgItems.vue'
	export default {
		components: {
			imgItems
		},
		//  数据获取从 vuex 获取
		props: {
			all_setting: {
				type: Array,
				default: () => {
					return []
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
			equipment: {
				type: String,
				default: "pc"
			},
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				show: true,
				list: []
			}
		},
		watch: {
			selectdItem: {
				immediate: true,
				deep: true,
				handler: function(newVal, oldVal) {
					console.log('newValnewVal', newVal)
					this.getImgList()
				}
			}
		},
		mounted() {
			if (!this.selectdItem.compontChildren[0].layoutConfig.img.typesetting) {
				this.$set(this.selectdItem.compontChildren[0].layoutConfig.img, 'typesetting', 'default')
			}

			if (!this.selectdItem.compontChildren[0].layoutConfig.img.isScale) {
				this.$set(this.selectdItem.compontChildren[0].layoutConfig.img, 'isScale', 'no')
			}
		},
		methods: {
			getImgList() {
				this.list = []
				this.selectdItem.compontChildren[0].data.img.list.forEach(item => {
					if (item.url != '') {
						this.list.push(item)
					}
				})
			},

			getColumnsLR() {
				let num = 1
				// let width;
				let columnGap;
				let rowGap;
				if (this.equipment == 'pc') {
					num = this.selectdItem.compontChildren[0].layoutConfig.img.pcNum
					// width = (num * this.selectdItem.compontChildren[0].layoutConfig.img.width) + (num * this.selectdItem.compontChildren[0].layoutConfig.img.columnGap)
					// width = width + 'px'
					columnGap = this.selectdItem.compontChildren[0].layoutConfig.img.columnGap
					rowGap = this.selectdItem.compontChildren[0].layoutConfig.img.rowGap


				} else {
					num = this.selectdItem.compontChildren[0].layoutConfig.img.phoneNum
					// width =  (num * this.selectdItem.compontChildren[0].layoutConfig.img.phoneWidth) + (num * this.selectdItem.compontChildren[0].layoutConfig.img.phoneColumnGap)
					// width = width + 'px'
					columnGap = this.selectdItem.compontChildren[0].layoutConfig.img.phoneColumnGap
					rowGap = this.selectdItem.compontChildren[0].layoutConfig.img.phoneRowGap
				}

				// console.log('widthwidth',width)
				// let borderWidth = parseInt(this.selectdItem.compontChildren[0].layoutConfig.img.border.borderSize[1]) + parseInt(this.selectdItem.compontChildren[0].layoutConfig.img.border.borderSize[3])
				return {

					// width,
					// paddingLeft:columnGap + 'px',
					gridRowGap: rowGap + 'px',
					gridColumnGap: columnGap + 'px',
					// paddingLeft:this.selectdItem.compontChildren[0].layoutConfig.img.border.borderSize[1] + 'px',
					// paddingRight:this.selectdItem.compontChildren[0].layoutConfig.img.border.borderSize[3] + 'px',

					gridTemplateColumns: `repeat(${num}, 1fr)`
				}
			},

			getColumns() {
				let num = 1
				let width;
				let columnGap;
				let rowGap;
				if (this.equipment == 'pc') {
					num = this.selectdItem.compontChildren[0].layoutConfig.img.pcNum
					width = (num * this.selectdItem.compontChildren[0].layoutConfig.img.width) + (num * this.selectdItem
						.compontChildren[0].layoutConfig.img.columnGap)
					width = width + 'px'
					columnGap = this.selectdItem.compontChildren[0].layoutConfig.img.columnGap
					rowGap = this.selectdItem.compontChildren[0].layoutConfig.img.rowGap


				} else {
					num = this.selectdItem.compontChildren[0].layoutConfig.img.phoneNum
					width = (num * this.selectdItem.compontChildren[0].layoutConfig.img.phoneWidth) + (num * this
						.selectdItem.compontChildren[0].layoutConfig.img.phoneColumnGap)
					width = width + 'px'
					columnGap = this.selectdItem.compontChildren[0].layoutConfig.img.phoneColumnGap
					rowGap = this.selectdItem.compontChildren[0].layoutConfig.img.phoneRowGap
				}

				console.log('widthwidth', width)
				console.log('columnGapcolumnGapcolumnGap', columnGap)
				return {
					// width,
					// paddingLeft:`${this.equipment == 'pc'?this.selectdItem.compontChildren[0].layoutConfig.img.columnGap: this.selectdItem.compontChildren[0].layoutConfig.img.phoneColumnGap}px`,
					gridRowGap: rowGap + 'px',
					gridColumnGap: columnGap + 'px',
					gridTemplateColumns: `repeat(${num}, calc(${parseInt(100 / num)}% - ${this.equipment == 'pc'?this.selectdItem.compontChildren[0].layoutConfig.img.columnGap: this.selectdItem.compontChildren[0].layoutConfig.img.phoneColumnGap}px))`
					// gridTemplateColumns: `repeat(auto-fill, calc(${parseInt(100 / num)}% - ${columnGap}px))`
				}
			},
		}
	}
</script>

<style>
</style>